import { MetricsEventsQueue } from "@cede/utils";

/** Shared by React and non-React tracking paths; one app-level transport drains it. */
export const metricsEventsQueue = new MetricsEventsQueue();

/** Identity changed — events created under the old identity must not be re-attributed. */
export const clearQueuedMetricsEvents = () => {
  metricsEventsQueue.invalidate();
};
